// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__rRQUG","loader":"Spinner_loader__AupXM"};